import { NavLink, Navigate, Outlet, useLocation } from "react-router-dom";

//STYLES && IMAGES
import './AdminLayout.css'
import Logo from '../../assets/imgs/logo-rc.png'

export default function AdminLayout() {
    const location = useLocation();

    if (location.pathname == '/admin') {
        return <Navigate to="/admin/dashboard"/>
    }

    return (
        <div className='admin-container'>
            <div className="admin-header">Admin Header</div>
            <div className="admin-content">
                <div className="admin-menu-container">
                    <div className="admin-menu">
                        <img src={Logo} alt="logo riches-claires" className="logo" />
                        <nav>
                            <ul>
                                <li className="menu-cat">Bar</li>
                                <ul className="sub-menu">
                                    <li><NavLink to='/admin/bar/tasks'>
                                        Manage tasks
                                        </NavLink>
                                    </li>
                                </ul>
                                <ul className="sub-menu">
                                    <li><NavLink to='/bar/home'>
                                        See front end
                                        </NavLink>
                                    </li>
                                </ul>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="admin-panel">
                    <Outlet/>
                    <div>Admin Footer</div>
                </div>
            </div>
        </div>
    )
}
